const content: { [key: string]: any } = {
  pageTitle: "Customer Member List",
  customerList: "Customer List",
  orderHistory: "Order History",
  customerTable: {
    customers: " Customers",
    name: " Name",
    tags: " Tag(s)",
    noOfOrders: "# of Orders",
    noOfVcsPv: "VCS PV/PV",
    lastOrdered: "Last Ordered",
    renewalDate: "Renewal Date",
    confidentialUser: "Confidential User",
    noData: "You have no customers or members to display in this view.",
  },
  customerListFilter: {
    all: "All",
    customerType: "Customer type",
    sort: "Sort",
    verified: "Verified",
    noVerified: "Non-Verified",
    newCustomer: "New",
    customer: "Customer",
    member: "Member",
    guest: "Guest Customer",
    sharebar: "Sharebar Customer",
    descLastOrderDate: "Recent order date",
    ascLastOrderDate: "Oldest order date",
    ascTotalCustomerPV: "Customer PV: Low - High",
    descTotalCustomerPV: "Customer PV: High - Low",
    ascNumberOrders: "Number of Orders: Low - High",
    descNumberOrders: "Number of Orders: High - Low",
    isCurrentMonthRenewalDate: "Renewal in Current Month",
  },
  orderFilter: {
    all: "All",
    orderType: "Order type",
    sort: "Sort",
    vcs: "VCS",
    nonVCS: "Non-VCS",
    return: "Return",
    order: "Order",
    uplift: "Uplift",
    adjustment: "Adjustment",
    reworks: "Rework",
    rms: "RMS Mass Upload Adjustment",
    cvr: "CVR",
    mars: "MARS",
    backdate: "Back Date",
    descOrderDate: "Recent order date",
    ascOrderDate: "Oldest order date",
    ascOrderPV: "Order PV: Low - High",
    descOrderPV: "Order PV: High - Low",
  },
  orderHistoryTable: {
    customerName: "Customer Name",
    orderDate: "Order Date",
    orderNumber: "Order Number",
    orderType: "Order Type",
    confidentialUser: "Confidential User",
    orders: "Orders",
    noOrders: {
      header: "You currently have no orders",
      subHeader: "New orders will be displayed here after your customer make a purchase or after you create a receipt",
      noOrdersFound: "No Orders Found",
    },
  },
  orderType: {
    nonVCSOrder: "Non-VCS Order",
    vcsOrder: "VCS Order",
    return: "Return",
    upliftOrder: "Uplift Order",
    adjustment: "Adjustment",
    reworks: "Rework",
    rmsAdjust: "RMS Mass Upload Adjustment",
    cvr: "CVR",
    mars: "MARS",
    backDate: "Back Date",
    other: "Other",
    order: "Order",
  },
  updatedAsOf: "Updated as of",
  search: "Search",
  filter: "Filter",
  pv: "PV",
  bv: "BV",
  vcsPv: "VCS PV",
  order: "Order",
  total: "Total:",
};

export default content;
